class RosviaPredictive {
  constructor(form, index) {
    this.form = form; this.input = form.querySelector('input[name="q"]');
    this.panel = document.createElement('div'); this.panel.className = 'predictive-panel'; this.panel.hidden = true;
    this.panel.id = `Predictive-${this.input.id || index}`;
    this.live = document.createElement('span'); this.live.className = 'visually-hidden'; this.live.setAttribute('aria-live', 'polite');
    form.append(this.panel, this.live); this.input.autocomplete = 'off';
    Object.entries({ role: 'combobox', 'aria-autocomplete': 'list', 'aria-expanded': 'false', 'aria-controls': this.panel.id, 'aria-haspopup': 'listbox' }).forEach(([key, value]) => this.input.setAttribute(key, value));
    this.version = 0; this.lastRequest = 0; this.active = -1;
    this.input.addEventListener('input', () => {
      this.close();
      const query = this.input.value.trim();
      if (!query) return;
      const version = this.version;
      this.showLoading();
      this.timer = setTimeout(() => this.search(query, version), Math.max(180, this.lastRequest + 180 - performance.now()));
    });
    this.input.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); this.close(); this.input.focus(); return; }
      if (this.panel.hidden) return;
      const options = [...this.panel.querySelectorAll('[role="option"]')];
      if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
        e.preventDefault(); this.active = (this.active + (e.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach((option, i) => option.setAttribute('aria-selected', String(i === this.active)));
        this.input.setAttribute('aria-activedescendant', options[this.active].id); options[this.active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.active >= 0) { e.preventDefault(); options[this.active].click(); }
    });
    form.addEventListener('focusout', e => { if (!form.contains(e.relatedTarget)) this.close(); });
    form.addEventListener('submit', () => this.close());
  }
  showLoading() {
    const skeleton = document.createElement('div'); skeleton.className = 'predictive-skeleton'; skeleton.setAttribute('aria-hidden', 'true');
    skeleton.innerHTML = '<span></span><span></span><span></span>';
    this.panel.replaceChildren(skeleton); this.panel.hidden = false; this.panel.classList.add('is-loading');
    this.input.setAttribute('aria-expanded', 'true'); this.input.setAttribute('aria-busy', 'true'); this.live.textContent = 'Searching';
  }
  close() { clearTimeout(this.timer); this.controller?.abort(); this.version++; this.panel.hidden = true; this.panel.classList.remove('is-loading'); this.input.setAttribute('aria-expanded', 'false'); this.input.removeAttribute('aria-activedescendant'); this.input.removeAttribute('aria-busy'); this.active = -1; }
  async search(query, version) {
    this.controller = new AbortController(); this.lastRequest = performance.now();
    const url = new URL(this.form.dataset.predictiveUrl, location.origin);
    url.search = new URLSearchParams({ q: query, 'resources[type]': 'product,collection,page,query', 'resources[limit]': '4', section_id: 'predictive-search' });
    try {
      const response = await fetch(url, { signal: this.controller.signal }); if (!response.ok) throw new Error();
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const results = doc.querySelector('[data-predictive-results]');
      if (!results || version !== this.version || !this.form.contains(document.activeElement)) return;
      this.panel.replaceChildren(results);
      this.panel.classList.remove('is-loading'); this.input.removeAttribute('aria-busy');
      const list = results.querySelector('[role="listbox"]'); list.id = `${this.panel.id}-list`;
      this.input.setAttribute('aria-controls', list.id);
      results.querySelectorAll('[role="option"]').forEach((el, i) => { el.id = `${this.panel.id}-option-${i}`; });
      this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true'); this.live.textContent = results.dataset.announcement;
    } catch (error) { if (error.name !== 'AbortError' && version === this.version) { this.close(); this.live.textContent = this.form.dataset.predictiveError; } }
  }
}
function initPredictive(scope = document) { scope.querySelectorAll('[data-predictive-url]').forEach((form, index) => { if (!form.predictiveController) form.predictiveController = new RosviaPredictive(form, index); }); }
initPredictive();
document.addEventListener('shopify:section:load', e => initPredictive(e.target));
document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-predictive-url]').forEach(form => form.predictiveController?.close()));
